module.exports = __webpack_public_path__ + "static/img/IPimg2.bf2062fe.png";